import React from "react";
import { withRouter } from "us.common/wIthRouter";
import Admin from "us.collection.admin";
import { useNavigate } from "react-router-dom";

interface ICntCreditorGroupHome {
  // caseNo: number;
}

const Cnt_NonProductionDaysHome: React.FC<ICntCreditorGroupHome> = (props) => {
  const  navigate = useNavigate();
  const onMinimize = (state: any) => {
    navigate(`/bureau`, { state });
  };

  return (
    <>
      <Admin.Components.CreditorGroup.CreditorGroupHome
        onMinimize={onMinimize}
        {...props}
      />
    </>
  );
};

export default withRouter(Cnt_NonProductionDaysHome);
